module.exports = __webpack_public_path__ + "static/img/icca.87f46530.png";